/* eslint-disable no-unused-vars */
import { decodeToken } from '@/utils/jwHelper'
import { queryUserInfo } from '@/api/index'
import store from '@/store'
const user = {
  namespaced: true,
  state: {
    token: window.localStorage.getItem('token'),
    userId: '',
    userInfo: null
  },
  getters: {
    token: (state) => state.token,
    userInfo: (state) => state.userInfo,
    userId: (state) => state.userId
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      window.localStorage.setItem('token', token)
    },
    SET_USER_ID(state, userId) {
      state.userId = userId
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
    }
  },
  actions: {
    setToken({ commit }, data) {
      commit('SET_TOKEN', data)
    },
    setUserId({ commit, state }) {
      const info = state.token ? decodeToken(state.token) : null
      commit('SET_USER_ID', info ? info.userId : '')
    },
    setUserInfo({ commit }, data) {
      commit('SET_USER_INFO', data)
    },
    logout({ commit, dispatch, state }) {
      commit('SET_TOKEN', '')
      commit('SET_USER_ID', '')
      commit('SET_USER_INFO', {})
      store.dispatch('menu/setCurrentTab', null)
      store.dispatch('menu/setTabs', [])
      store.dispatch('menu/setCustomerInfo', {})
      store.dispatch('menu/setOrgList', [])
      window.localStorage.setItem('orgIDList', [])
      if (window.localStorage.getItem('vuex')) {
        window.localStorage.removeItem('vuex')
      }
    },
    getUserInfo({ commit, dispatch, state }) {
      dispatch('setUserId')
      return new Promise((resolve, reject) => {
        // TODO
        queryUserInfo(state.userId)
          .then((res) => {
            console.log('🚀 ~ queryUserInfo ~ res:', res)
            dispatch('setUserInfo', res.data)
            resolve()
          })
          .catch((err) => {
            console.log('🚀 ~ queryUserInfo ~ err:', err)
          })
      })
    }  
  }
}

export default user
